import { useShop } from '@services/ShopProvider';

// The sidebar links to /settings/billing without a shopId, so useShop() resolves
// the current shop to an empty object. Fall back to the first shop with billing
// set up — chains share one Stripe customer across every location, so any
// sibling's stripeCustomerId reads the same org-wide billing.
export const useBillingShop = () => {
	const { shop, data } = useShop();
	if (shop.stripeCustomerId) {
		return shop;
	}
	return data?.find((s) => s.stripeCustomerId) || (shop.id ? shop : data?.[0]) || {};
};
